import React from 'react';
import { useTheme, alpha } from '@mui/material/styles';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemLink from './list-item-link';
import { StyledListItemText, TrailListContainer } from './styles';

const TrailList = ({ page, toggleDrawer }) =>
  <TrailListContainer className="sub-menu" onClick={toggleDrawer}>
    {page.subMenuList?.map(subPage => (
      <div key={subPage.label}>
        <ListItemLink
          to={subPage.route}
          externalRedirect={page.externalRedirect}
          aria-label={subPage.label}
        >
          <StyledListItemText primary={subPage.label} />
        </ListItemLink>
      </div>
    ))}
  </TrailListContainer>;

const MobileListItem = ({
  page,
  isTrail,
  subMenu,
  toggleDrawer,
  setItemsState,
  selected
}) => {
  const theme = useTheme();
  const toggleSubMenu = () => {
    setItemsState(prevState => ({
      ...prevState,
      [page.label]: !prevState[page.label]
    }));
  };

  const onListItemClick = event => {
    if (isTrail) {
      event.stopPropagation();
    }
    toggleSubMenu();
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={e => onListItemClick(e)}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          onListItemClick(e);
        }
      }}
      data-key={page.label}
      key={page.label}
      style={{
        backgroundColor: selected ?
          alpha(theme.palette.secondary.main, 0.25) :
          '#FFF'
      }}
    >
      {page.divider}
      <ListItemLink
        to={page.route}
        onClickHandler={page.onClickHandler ?? null}
        aria-label={page.label}
      >
        <ListItemIcon data-key={page.label}>{page.icon}</ListItemIcon>
        <StyledListItemText primary={page.label} />
      </ListItemLink>
      {subMenu ?
        <TrailList
          page={page}
          toggleDrawer={toggleDrawer}
        /> :
        null}
    </div>
  );
};

export default MobileListItem;
